module.exports = __webpack_public_path__ + "img/0Q3B3739_Black.7b7f45c6.jpg";